import React, { useState } from 'react';
import { Button, Form, Input, Typography, message } from 'antd';
import { requestPasswordReset } from '../../utils/api';

const AdminForgotPasswordPage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const vals = await form.validateFields();
      await requestPasswordReset(vals.email);
      message.success('パスワードリセット用のリンクをメールに送信しました');
    } catch (e: any) {
      if (e?.errorFields) return; // validation error
      message.error(e?.response?.data?.error || 'リクエストに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-[0px_0px_3px_0px_#00000033] p-6">
        <Typography.Title level={3} style={{ textAlign: 'center', marginBottom: 16 }}>パスワードをお忘れの場合</Typography.Title>
        <Form layout="vertical" form={form} onFinish={onSubmit}>
          <Form.Item label="登録メールアドレス" name="email" rules={[{ required: true, message: 'メールを入力してください' }, { type: 'email', message: '正しいメール形式で入力してください' }]}>
            <Input className='base-input' placeholder="you@example.com" />
          </Form.Item>
          <Button className='mt-4 base-button h-[46px] w-[276px]' type="primary" htmlType="submit" block loading={loading}>リセットリンクを送信</Button>
          <div className="text-right mt-3">
            <a href="/admin/login" className="text-[#0077C8]">ログインに戻る</a>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;
